import { FileTypes } from 'api/services/file/types';
import { FormType, IForm, IFormView } from 'shared/Form/types';

export const fields: IForm = {
	favicon: {
		type: FormType.FILE,
		value: '',
		width: 16,
		height: 16,
		fileType: FileTypes.IMAGE,
		label: 'Favicon',
		extraKey: 'favicon',
	},
	ogImage: {
		type: FormType.FILE,
		value: '',
		fileType: FileTypes.IMAGE,
		label: 'Картинка для соц сетей',
		extraKey: 'ogImage',
	},
	name: {
		type: FormType.TEXT,
		value: '',
		required: true,
		label: 'Название сайта',
		extraKey: 'name',
	},
	title: {
		type: FormType.TEXT,
		value: '',
		label: 'Заголовок',
		extraKey: 'title',
	},
	description: {
		type: FormType.TEXTAREA,
		label: 'Описание',
		value: '',
		extraKey: 'description',
	},
	keywords: {
		type: FormType.TEXTAREA,
		value: '',
		label: 'Ключевые слова',
		extraKey: 'keywords',
	},
	email: {
		type: FormType.TEXT,
		value: '',
		label: 'Email',
		extraKey: 'email',
	},
	slogan: {
		type: FormType.TEXT,
		value: '',
		label: 'Слоган',
		extraKey: 'slogan',
	},
	phone: {
		type: FormType.TEXT,
		value: '',
		label: 'Телефон',
		extraKey: 'phone',
	},
	address: {
		type: FormType.TEXT,
		value: '',
		label: 'Адрес',
		extraKey: 'address',
	},
	socs: {
		type: FormType.REPEATER,
		value: [],
		label: 'Социальные сети',
		extraKey: 'socs',
		initialValue: {
			icon: {
				type: FormType.FILE,
				value: '',
				label: 'Иконка',
				required: true,
				fileType: FileTypes.IMAGE,
				extraKey: 'icon',
			},
			title: {
				type: FormType.TEXT,
				value: '',
				label: 'Название',
				extraKey: 'title',
			},
			link: {
				type: FormType.TEXT,
				value: '',
				label: 'Ссылка',
				required: true,
				extraKey: 'link',
			},
		},
		view: [['icon'], ['title'], ['link']],
	},
	logo: {
		type: FormType.FILE,
		fileType: FileTypes.IMAGE,
		value: '',
		label: 'Лого',
		extraKey: 'logo',
	},
};

export const view: IFormView = [
	{
		title: 'Основные настройки',
		block: [['sitename'], ['slogan'], ['logo'], ['favicon']],
	},
	{
		title: 'Контакты',
		block: [['email'], ['phone'], ['address'], ['socs']],
	},
	{
		title: 'SEO',
		block: [['title'], ['description'], ['keywords'], ['ogImage']],
	},
];
